import React from "react";

const DashboardWelcome = () => {
  return (
    <div className="flex justify-center my-40">
      <h1 className="text-3xl font-bold text-gray-800 lg:text-4xl">
        Welcome to Dashboard!
      </h1>
    </div>
  );
};

export default DashboardWelcome;
